import plutoBold from '@vds/core/dist/assets/fonts/PlutoTVSansV11/PlutoTVSansV11-Bold.woff2?url';
import plutoMedium from '@vds/core/dist/assets/fonts/PlutoTVSansV11/PlutoTVSansV11-Medium.woff2?url';
import plutoRegular from '@vds/core/dist/assets/fonts/PlutoTVSansV11/PlutoTVSansV11-Regular.woff2?url';
import plutoSemiBold from '@vds/core/dist/assets/fonts/PlutoTVSansV11/PlutoTVSansV11-SemiBold.woff2?url';
import proximaBlack from '@vds/core/dist/assets/fonts/ProximaNova/ProximaNova-A-Black.woff2?url';
import proximaBold from '@vds/core/dist/assets/fonts/ProximaNova/ProximaNova-A-Bold.woff2?url';
import proximaRegular from '@vds/core/dist/assets/fonts/ProximaNova/ProximaNova-A-Regular.woff2?url';
import proximaSemiBold from '@vds/core/dist/assets/fonts/ProximaNova/ProximaNova-A-SemiBold.woff2?url';

export type FontLob = 'pplus' | 'ptv';

/** Above-the-fold weights per LOB — keep this list small to avoid wasting bandwidth. */
export const CRITICAL_FONTS_BY_LOB: Record<FontLob, readonly string[]> = {
    pplus: [proximaBlack, proximaBold, proximaSemiBold, proximaRegular],
    ptv: [plutoBold, plutoSemiBold, plutoMedium, plutoRegular],
};
